import * as React from 'react';

type Props = {
    value: number;
    type: number;
    onChange: (value: { value: number, type: number }) => void;
};

type State = {

}

export default class LengthInput extends React.Component<Props, State> {

    private input1: React.RefObject<HTMLInputElement>;
    private input2: React.RefObject<HTMLInputElement>;

    constructor(props: Props) {
        super(props);

        this.input1 = React.createRef();
        this.input2 = React.createRef();

        this.getValue = this.getValue.bind(this);
        this.getInchValue = this.getInchValue.bind(this);
        this.getTypeName = this.getTypeName.bind(this);
        this.onChangeValue = this.onChangeValue.bind(this);
        this.onInchChangeValue = this.onInchChangeValue.bind(this);
        this.onChangeType = this.onChangeType.bind(this);
    }

    public render() {
        return <React.Fragment>
            <input
                ref={this.input1}
                className="form-control"
                type="number"
                min={0}
                value={this.getValue()}
                onChange={(e) => this.onChangeValue(e.target.value)}
            />
            {this.props.type === 1 &&
            <input
                ref={this.input2}
                className="form-control"
                type="number"
                min={0}
                value={this.getInchValue()}
                onChange={(e) => this.onInchChangeValue(e.target.value)}
            />}
            <div className="input-group-append">
                <button className="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{this.getTypeName()}</button>
                <div className="dropdown-menu">
                    <button type="button" className="dropdown-item" onClick={() => this.onChangeType(0)}>Centimeters</button>
                    <button type="button" className="dropdown-item" onClick={() => this.onChangeType(1)}>Feet/Inches</button>
                </div>
            </div>
        </React.Fragment>
    }

    private onChangeValue(value: string) {
        let parsedValue = parseInt(value) || 0;
        if (this.props.type === 1 && this.input2.current) {
            const parsedInches = parseInt(this.input2.current.value) || 0;
            const realFeet = parsedValue + (parsedInches / 12);
            parsedValue = realFeet * 30.48;
        }
        this.props.onChange({ value: parsedValue, type: this.props.type });
    }

    private onInchChangeValue(value: string) {
        let parsedValue = parseInt(value) || 0;
        if (this.input1.current && this.props.type === 1) {
            const parsedFeet = parseInt(this.input1.current.value) || 0;
            const realFeet = parsedFeet + (parsedValue / 12);
            parsedValue = realFeet * 30.48;
            this.props.onChange({ value: parsedValue, type: this.props.type });
        }
    }

    private onChangeType(type: 0|1) {
        this.props.onChange({ value: this.props.value, type });
    }

    private getValue() {
        switch(this.props.type) {
            case 1:
                return Math.floor((this.props.value * 0.393700) / 12);
            default:
                return Math.round(this.props.value);
        }
    }

    private getInchValue() {
        if (this.props.type === 1) {
            const realFeet = ((this.props.value * 0.393700) / 12);
            return Math.round((realFeet - Math.floor(realFeet)) * 12);
        }
    }

    private getTypeName() {
        switch(this.props.type) {
            case 0:
                return "Centimeters";
            case 1:
                return "Feet/Inches";
            default:
                throw "Invalid Length Type!";
        }
    }
}
